<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="head">
      <div class="label" *ngIf="!editDriver">
        {{'spotOn.re_assign_spot_vehicle' | translate}}
        <i class="material-icons" (click)="closeDialog();">
          clear
        </i>
      </div>
      <div class="label" *ngIf="editDriver">
        {{'spotOn.editSpotDriver' | translate}}
        <i class="material-icons" (click)="closeDialog();">
          clear
        </i>
      </div>
    </div>
    <div class="body">
      <div class="left">

        <div class="inputContainer">
          <div class="label">
            {{'spotOn.vehicleNum' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
          </div>
          <input type="text" [(ngModel)]="spotVehicleData.vehicle_no" [placeholder]="vehicle_pattern">
        </div>
        <div class="inputContainer">
          <div class="label">
            {{'spotOn.gps_provider' | translate}}
          </div>
          <mat-select class="inputSelect" style="color: #fff;" [(ngModel)]="selectedGPSProvider">
            <mat-option *ngFor="let provider of gps_providers" [value]="provider" (click)="selectGPSProvider(provider)">
              {{provider.name}}
            </mat-option>
          </mat-select>
        </div>
        <div style="display:inline-flex;" *ngIf="spinner">
          <span>
            <mat-spinner [diameter]="20" style="position: relative;top: 30px;"></mat-spinner>
          </span>
        </div>
        <div class="formElement" *ngIf="showGPSProvider && assetsArray && assetsArray.length">
          <div class="formLabel">
            {{'ADD_VEHICLE.asset' | translate}}
          </div>
          <div class="formInput">
            <input class="form-input" type="text" (keyup)="applyFilter($event.target.value)"
              [matAutocomplete]="auto_assets" [(ngModel)]="selectedAsset">
            <mat-autocomplete #auto_assets="matAutocomplete">
              <mat-option *ngFor="let asset of assets" [value]="asset.reg_number" (click)="selectAsset(asset)">
                <span>
                  {{asset.reg_number}}
                </span>
              </mat-option>
            </mat-autocomplete>
          </div>
        </div>
      </div>
      <div class="right">

        <div class="inputContainer" *ngIf="!editDriver">
          <div class="label">
            {{'spotOn.vehicleType' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
          </div>
          <input type="text" [matAutocomplete]="vehicleTy" [(ngModel)]="vehicleType1.name">
          <mat-autocomplete #vehicleTy="matAutocomplete" (optionSelected)='selectVehicle($event.option.value)'>
            <mat-option *ngFor="let type of vehicles | search:vehicleType1.name:'vehicle'" [value]="type">
              <span>{{type.name}}</span>
            </mat-option>
          </mat-autocomplete>
        </div>
        <div class="inputContainer" style="margin-top:10px ;" *ngIf="editDriver">
          <div class="label">
            {{'spotOn.selectedVehicleType' | translate}} : {{selectedVehicleType.name}}
          </div>
          <div class="label">
            <mat-checkbox (change)="selectVehicleType($event)" [(ngModel)]="checked">{{'spotOn.changeVehicleType' |
              translate}}</mat-checkbox>
          </div>
          <div class="label" *ngIf="checked">
            {{'spotOn.vehicleType' | translate}}<span><sup style="color: #ff0000;">*</sup></span>
          </div>
          <input type="text" *ngIf="checked" [matAutocomplete]="vehicleTy" [(ngModel)]="vehicleType.name">
          <mat-autocomplete #vehicleTy="matAutocomplete" (optionSelected)='selectVehicle($event.option.value)'>
            <mat-option *ngFor="let type of vehicles | search:vehicleType.name:'vehicle'" [value]="type">
              <span>{{type.name}}</span>
            </mat-option>
          </mat-autocomplete>
        </div>
        <div class="inputContainer" *ngIf="showGPSProvider && assetsArray && assetsArray.length">
          <div class="label">
            {{'spotOn.asset' | translate}}
          </div>
          <input type="text" (keyup)="applyFilter($event.target.value)" [matAutocomplete]="auto_assets"
            [(ngModel)]="selectedAsset">
          <mat-autocomplete #auto_assets="matAutocomplete">
            <mat-option *ngFor="let asset of assets" [value]="asset.reg_number" (click)="selectAsset(asset)">
              <span>
                {{asset.reg_number}}
              </span>
            </mat-option>
          </mat-autocomplete>
        </div>
        <div class="submitButton" *ngIf="!editDriver" (click)="addSpotVehicle();">
          <div class="button">
            {{'spotOn.add_vehicle' | translate}}
          </div>
        </div>
        <div class="submitButton" *ngIf="editDriver" (click)="addSpotVehicle();">
          <div class="button">
            {{'spotOn.update' | translate}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>